// Reapply as variants arrive; do not disable every level before heights are known.
export function applyPlaybackQuality (levels, highest) {
  const variants = Array.from({ length: levels.length }, (_, i) => levels[i])
  const height = Math.max(0, ...variants.map(level => level.height || 0))
  variants.forEach(level => { level.enabled = !highest || !height || level.height === height })
}
